import { createFileRoute } from '@tanstack/react-router';

import { StatisticsPage } from '@dashboard';

export const Route = createFileRoute('/_app/dashboard')({
  component: StatisticsPage,
  pendingComponent: StatisticsPage.Pending,
  errorComponent: StatisticsPage.Error,
});
